import "babel-polyfill"
import page from "@src/page"

export const wrapPageElement = page
